/**
 * スキャンを開始します
 * cordova環境でない場合は、10秒経過後にモックの値を含んでResolveします。
 */
export const startScan = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    // @ts-ignore
    const qrScanner = window.QRScanner;
    if (qrScanner === undefined) {
      console.log("skipped: QRScanner startScan");
      alert("カメラが利用できません");
      return reject({ _message: "カメラが利用できません", code: 5, name: "" });
    }
    qrScanner.scan(
      (err: { _message: string; code: number; name: string }, text: string) => {
        if (err) {
          console.warn(JSON.stringify(err));

          // ref: https://github.com/bitpay/cordova-plugin-qrscanner#possible-error-types
          switch (err.code) {
            case 0:
              alert("不明なエラーが発生しました");
              break;
            case 1:
              alert(
                "カメラへのアクセスが拒否されました。設定を確認してください。"
              );
              break;
            case 2:
              alert(
                "カメラへのアクセスが制限されてます。設定を確認してください。"
              );
              break;
            case 3:
              alert("バックカメラが利用できません。設定を確認してください。");
              break;

            case 4:
              alert("フロントカメラが利用できません。設定を確認してください。");
              break;
            case 5:
              alert("カメラが利用できません");
              break;
            case 6:
              // Scan was canceled by the cancelScan() method. (Returned exclusively to the QRScanner.scan() method.)
              break;
            case 7:
              alert("ライトが利用できません");
              break;
          }
          return reject(err);
        }
        return resolve(text);
      }
    );

    qrScanner.show();
  });
};

/**
 * スキャンを停止します
 */
export const stopScan = () => {
  // @ts-ignore
  const qrScanner = window.QRScanner;
  if (qrScanner === undefined) {
    console.log("skipped: QRScanner stopScan");
    return;
  }
  /**
   * HACK: hide()では非表示にならなかったため、destroyを利用
   */
  qrScanner.destroy();
};

type QrCodeScannerStatus = {
  authorized: boolean;
  denied: boolean;
  restricted: boolean;
  prepared: boolean;
  scanning: boolean;
  previewing: boolean;
  showing: boolean;
  lightEnabled: boolean;
  canOpenSettings: boolean;
  canEnableLight: boolean;
  currentCamera: number;
};
export const getStatus = () => {
  return new Promise(resolve => {
    // @ts-ignore
    const qrScanner = window.QRScanner;
    if (qrScanner === undefined) {
      console.log("skipped: QRScanner getStatus");
      resolve(null);
    }
    qrScanner.getStatus((status: QrCodeScannerStatus) => {
      resolve(status);
    });
  });
};
